import './index.scss'
import React, { useEffect, useState, useCallback } from 'react'
import { Modal, Input, Empty, message } from 'antd'
import { fetchLocations } from '../../../actions/photo'
import Address from './components/Address'
import { useAppDispatch } from '../../../app/hooks'
import { EnvironmentOutlined } from '@ant-design/icons'

const { Search } = Input

type Location = {
  name: string
  detail: string
  type: number
}

type ListDomProps = {
  top: number
  clientHeight: number
}

interface ILocationPickerProps {
  visible: boolean
  groupId: string
  onCancel: () => void
  handleCheckLocation: (location: Location) => void
}

const LocationPicker: React.FC<ILocationPickerProps> = ({
  visible,
  groupId,
  onCancel,
  handleCheckLocation
}) => {
  const [locations, setLocations] = useState<Location[]>([])
  const [keyword, setKeyword] = useState<string>('')
  const [searchVal, setSearchVal] = useState<string>('')
  const [emptyText, setEmptyText] = useState<string>('无最近拍照地点')
  const [loading, setLoading] = useState<boolean>(false)
  const [cursor, setCursor] = useState<string>('-1')
  const dispatch = useAppDispatch()
  let isRefreshing = false

  const queryLocatons = async (
    keyword: string,
    cursor: string
  ): Promise<Location[]> => {
    try {
      const res = await dispatch(
        fetchLocations({
          groupID: groupId,
          keyword,
          cursor
        })
      )

      const { status, msg, payload, nextCursor } = res

      if (status !== 0) {
        message.error(msg)
      }

      setCursor(nextCursor)
      setKeyword(keyword)

      return payload
    } catch (e) {
      console.log(e)

      return []
    }
  }

  const handleSearch = (keyword: string) => {
    setKeyword(keyword)
    setEmptyText('无相关地点')

    setLoading(true)

    queryLocatons(keyword, '-1')
      .then((res) => {
        setLocations(res)
        setLoading(false)
      })
      .catch(() => {
        setLoading(false)
      })
  }

  useEffect(() => {
    if (visible) {
      queryLocatons('', '-1').then((res) => {
        setLocations(res)
      })
    }
  }, [visible])

  const resetStatus = () => {
    setSearchVal('')
    setKeyword('')
    setLocations([])
  }

  const handleScroll = (e) => {
    if (cursor === '0') {
      return
    }

    const dom = e.target

    if (dom.scrollHeight - dom.scrollTop === dom.clientHeight) {
      if (!isRefreshing) {
        isRefreshing = true

        queryLocatons(keyword, cursor)
          .then((res) => {
            setLocations([...locations, ...res])
            isRefreshing = false
          })
          .catch(() => {
            isRefreshing = false
          })
      }
    }
  }

  return (
    <Modal
      wrapClassName="location-picker-modal"
      open={visible}
      title="筛选地点"
      onCancel={() => {
        onCancel()
        resetStatus()
      }}
      mask={{ closable: false }}
      footer={null}
      styles={{ body: { padding: 10 } }}
      width={600}
    >
      <div className="container">
        <Search
          value={searchVal}
          onChange={(e) => {
            setSearchVal(e.target.value)
          }}
          onSearch={handleSearch}
          loading={loading}
          placeholder="可搜索省、市、区、地点等"
        />

        {locations.length === 0 && (
          <div className="empty">
            <Empty description={emptyText} />
          </div>
        )}
        {locations.length > 0 && (
          <div className="list" onScroll={handleScroll}>
            {locations.map(({ name, detail, type }, index) => (
              <div
                className="item"
                key={index}
                onClick={() => {
                  handleCheckLocation({
                    name,
                    detail,
                    type
                  })

                  resetStatus()
                }}
              >
                <EnvironmentOutlined
                  style={{ color: '#969799', fontSize: 16 }}
                />
                <div className="address">
                  <Address address={name} keyword={keyword} />
                </div>
                <div className="detail">
                  <Address address={detail} keyword={keyword} />
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </Modal>
  )
}

export default LocationPicker
